<template>
  <div class="">
    <div class="landingHeader py-1">
      <div class="container">
        <div class="extra-health-home-google-translate d-flex justify-content-end">
          <GoogleTranslate />
        </div>
        <div class="row align-items-center">
          <div class="col-6 col-sm-6 col-md-5 col-lg-5">
            <img src="../../views/AetnaDentalLanding/images/aetnadental.png" class="w-100 img-fluid" alt="">
          </div>
          <div class="col-6 col-sm-6 col-md-3 col-lg-3">
            <img src="../../views/AetnaDentalLanding/images/teledental.png" class="img-fluid" alt="" />
          </div>
          <div class="col-6 col-sm-6 col-md-1 col-lg-1">
            <img src="../../views/AetnaDentalLanding/images/outlook.jpeg" class="img-fluid" alt="" />
          </div>
          <div class="col-6 col-sm-6 col-md-3 col-lg-3">
            <img src="../../views/AetnaDentalLanding/images/mg.png" class="img-fluid" alt="" />
          </div>
          <!-- <div class="col-lg-10 col-12">
            <div class="logoList">
              <img src="../../views/AetnaDentalLanding/images/aetnadental.png" class="aetnaLogo" alt="">
              <ul>
                <li>
                  <img src="../../views/AetnaDentalLanding/images/images/teledental.png" alt="">
                </li>
                <li>
                  <img src="../../views/AetnaDentalLanding/images/outlook.jpeg" alt="">
                </li>
                <li>
                  <img src="../../views/AetnaDentalLanding/images/mg.png" style="max-width: 250px;" alt="">
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="enrollNow">
              <button class=""  v-b-modal.aetna-modal>Click Here</button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../views/AetnaDentalLanding/styles/style.css";
import GoogleTranslate from "../GoogleTranslate";
export default {
  name: "Footer",
  components:{
    GoogleTranslate
  }
};
</script>
<style>
.extra-health-home-google-translate {
  position: relative;
  top: 0px;
  right: 0px;
}
</style>